import { HStack, Text } from '@chakra-ui/react';

interface DetailRowProps {
  label: string;
  value: string;
  dataE2e?: string;
}

export function DetailRow({ label, value, dataE2e }: DetailRowProps) {
  return (
    <HStack
      justify="space-between"
      py={2}
      borderBottom="1px solid"
      borderColor="border.subtle"
      data-e2e={dataE2e}
    >
      <Text
        fontSize="sm"
        color="text.secondary"
        fontWeight="500"
        data-e2e={dataE2e ? `${dataE2e}-label` : undefined}
      >
        {label}
      </Text>
      <Text
        fontSize="sm"
        fontWeight="500"
        data-e2e={dataE2e ? `${dataE2e}-value` : undefined}
      >
        {value}
      </Text>
    </HStack>
  );
}
